import { render, staticRenderFns } from "./widget_voice_session.vue?vue&type=template&id=6a02aa22&"
import script from "./widget_voice_session.vue?vue&type=script&lang=js&"
export * from "./widget_voice_session.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports